var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"navigation":""}},[(_vm.show)?_c('div',[_c('NaturalPersonCardList',{attrs:{"items":_vm.mine_patients},on:{"org:click":_vm.onPersonClick}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }